import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { Box } from '@mui/material';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import Sidebar from './components/Sidebar';
import Dashboard from './pages/Dashboard';
import Events from './pages/Events';
import Orders from './pages/Orders';
import Reviews from './pages/Reviews';
import QRScanner from './pages/QRScanner';
import Login from './pages/Login';

// Main app content (protected)
const AppContent = () => {
  const { isAuthenticated, loading, user } = useAuth();

  console.log('AppContent - Auth state:', { isAuthenticated, loading, user });

  if (loading) {
    return null; // Loading is handled by ProtectedRoute
  }

  if (!isAuthenticated) {
    console.log('AppContent - Not authenticated, redirecting to login');
    return <Navigate to="/login" replace />;
  }

  console.log('AppContent - Authenticated, rendering protected content');

  return (
    <Box sx={{ display: 'flex', minHeight: '100vh', bgcolor: 'background.default' }}>
      <Sidebar />
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          width: { md: `calc(100% - 264px)` },
          px: { xs: 2, md: 4 },
          py: { xs: 2, md: 3 },
          mt: { xs: '60px', md: '68px' },
        }}
      >
        <Routes>
          <Route path="/" element={<Navigate to="/dashboard" replace />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/events" element={<Events />} />
          <Route path="/orders" element={<Orders />} />
          <Route path="/reviews" element={<Reviews />} />
          <Route path="/qr-scanner" element={<QRScanner />} />
        </Routes>
      </Box>
    </Box>
  );
};

// Main app component
function App() {
  return (
    <AuthProvider>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/*" element={
          <ProtectedRoute>
            <AppContent />
          </ProtectedRoute>
        } />
      </Routes>
    </AuthProvider>
  );
}

export default App;
